import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import PropTypes from "prop-types";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { AnimatePresence } from "framer-motion";
import PageTransition from "../common/PageTransition";

export default function Layout({ children }) {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <AnimatePresence mode="wait">
        <main
          key={location.pathname}
          id="main-content"
          tabIndex={-1}
          className="mx-auto max-w-7xl px-6 pb-8 sm:px-8 lg:px-12"
        >
          <PageTransition>{children}</PageTransition>
        </main>
      </AnimatePresence>
      <Footer />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
